// import React from "react";
// import "./registerManagement.css";
// import OverviewCard from "../../components/OverView-Card/overview-card";
// import RegistrationTable from "../../components/Registration-table/registration-table";
// import PopularBond from "../../components/Popular-bond/Popular-bond";
// import RegistartionDetail from "../../components/Registration-details/Registartion-detail";
// import RegistartionTableWealth from "../../components/Registration-table-wealth";
// function RegistrationManagemnet() {
//   return (
// <main class="main-content">
//   <div class="tabs">
//     <button class="tab active">Investor</button>
//     <button class="tab">Wealth Partner</button>
//   </div>
//   <div class="search-section">
//     <input
//       type="text"
//       placeholder="Search by Unique ID/name"
//       class="search-input"
//     />
//     <button class="search-button">Search</button>
//     <div class="filter-section">
//       <label for="kyc-status">OR search by KYC Status</label>
//       <select id="kyc-status" class="select-dropdown">
//         <option value="all">All</option>
//       </select>
//       <label for="wealth-partner">Referred by Wealth Partner</label>
//       <select id="wealth-partner" class="select-dropdown">
//         <option value="all">All</option>
//       </select>
//       <button class="download-button">Download</button>
//     </div>
//   </div>
//   <table class="data-table">
//     <thead>
//       <tr>
//         <th>UCC Code</th>
//         <th>Investor Name</th>
//         <th>KYC Status</th>
//         <th>Registration Date</th>
//         <th>Referred by Wealth Partner</th>
//         <th>Action</th>
//       </tr>
//     </thead>
//     <tbody>
//       {[
//         1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 1, 14, 15, 16, 17, 18, 19, 20,
//         21,
//       ].map((i) => (
//         <tr>
//           <td>IN00012</td>
//           <td>CHETAN DILIP GHARMALKAR</td>
//           <td>
//             <span class="status pending">Pending</span>
//           </td>
//           <td>06-11-2024</td>
//           <td>John Doe</td>
//           <td>
//             <button class="action-button">View</button>
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
//   <div class="pagination">
//     <button class="pagination-button" disabled>
//       Previous
//     </button>
//     <span>Page 1 of 10</span>
//     <button class="pagination-button">Next</button>
//   </div>
// </main>

//     <div class="dashboard">
//       {/* <aside class="sidebar"> <!-- Sidebar content here --> </aside> */}
//       <main class="main-content">
//         {/* <header class="header"> <!-- Header content here --> </header> */}
//         <div class="dashboard-content">
//           <section class="overview-cards">
//             {/* <!-- Overview cards content here --> */}
//             {/* <OverviewCard /> */}
//           </section>
//           <div class="dashboard-grid">
//             <section class="registration-table">
//               <RegistrationTable />
//               {/* <!-- Registration table content here --> */}
//             </section>
//             <section class="popular-bonds">
//               <PopularBond />
//               {/* <!-- Popular bonds content here --> */}
//             </section>
//           </div>
//           <div className="registartion-details-container">
//             <RegistartionDetail />
//           </div>
//         </div>
//       </main>

//       <main class="main-content">
//         <div class="tabs">
//           <button class="tab-button active" data-tab="investor">
//             Investor
//           </button>
//           <button class="tab-button" data-tab="wealth-partner">
//             Wealth Partner
//           </button>
//         </div>
//         <div class="tab-content">
//           <div class="tab-pane active" id="investor">
//             <RegistartionTableWealth />
//             {/* <!-- Registration table for Investor will go here --> */}
//           </div>
//           <div class="tab-pane" id="wealth-partner">
//             {/* <!-- Registration table for Wealth Partner will go here --> */}
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// }

// export default RegistrationManagemnet;

import React, { useEffect, useState } from "react";
import "./registerManagement.css";
import OverviewCard from "../../components/OverView-Card/overview-card";
import RegistrationTable from "../../components/Registration-table/registration-table";
import PopularBond from "../../components/Popular-bond/Popular-bond";
import RegistartionDetail from "../../components/Registration-details/Registartion-detail";
import RegistartionTableWealth from "../../components/Registration-table-wealth";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import download from "../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../components/ReactTable";
import eye from "../../assets/eye.png";
import CustomPagination from "../../components/CustomPagination";
import axios from "axios";
import { useSelector } from "react-redux";
import InvitePartner from "../../components/Registration-table-wealth/InvitePartnerModal";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
function RestrationManagementPartner() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Wealth Partner");
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectedReferal, setSelectedReferal] = useState(null);
  const [selectNumber, setSelectedNumber] = useState("10");
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");
  const [investorDetails, setInvestorDetails] = useState([]);
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("registrationManagementPartnerPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);
  const [isOpenInviteModal, setIsOpenInviteModal] = useState(false);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  const [error, setError] = useState(null);

  const optionsOccupation = [
    "All",
    "Pending",
    "Under Review",
    "Approve",
    "Query Raised",
    "Update Request",
  ];
  const transformStatus = (status) => {
    switch (status) {
      case "All":
        return "";
      case "Pending":
        return "pending";
      case "Under Review":
        return "under_review";
      case "Approve":
        return "approve";
      case "Query Raised":
        return "query";
      case "Update Request":
        return "update_request";
      default:
        return "";
    }
  };

  const optionsRefered = ["All"];

  const optionsShow = ["All", "10", "20", "50"];
  const buttonData = [
    {
      label: "Investor",
      path: "/registration/investor", // Path for the Investor button
    },
    {
      label: "Wealth Partner",
      path: "/registration/wealth-partner", // Path for the Wealth Partner button
    },
  ];
  const investorsData = [
    {
      investorName: "CHETAN DILIP GHARMALKAR",
      uccCode: "---",
      kycStatus: "Pending",
      registrationDate: "06-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "KARVY CAPITAL ARBITRAGE OPPORTUNITIES FUND",
      uccCode: "IN0011",
      kycStatus: "Under Review",
      registrationDate: "05-11-2024",
      referredBy: "--",
      action: "view",
    },
    {
      investorName: "HCC SAMSUNG JOINT VENTURE",
      uccCode: "IN0010",
      kycStatus: "Approve",
      registrationDate: "05-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "GLOBAL INVESTMENTS LTD",
      uccCode: "---",
      kycStatus: "Pending",
      registrationDate: "04-11-2024",
      referredBy: "--",
      action: "view",
    },
    {
      investorName: "SUNNYVALE TECH SOLUTIONS",
      uccCode: "IN0012",
      kycStatus: "Under Review",
      registrationDate: "04-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "GREEN ENERGY INNOVATIONS",
      uccCode: "IN0007",
      kycStatus: "Approve",
      registrationDate: "04-11-2024",
      referredBy: "--",
      action: "view",
    },
    {
      investorName: "BLUE OCEAN STRATEGIES",
      uccCode: "IN0013",
      kycStatus: "Under Review",
      registrationDate: "03-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "BLUE OCEAN STRATEGIES",
      uccCode: "IN0005",
      kycStatus: "Approve",
      registrationDate: "03-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
  ];

  const columnHelper = createColumnHelper();

  const handleClick = (path, label) => {
    setActiveTab(label);
    navigate(path); // Navigate to the given path
  };

  const handleSelectOccupation = (value) => {
    setPage(1);
    setSelectedOccupation(value);
  };

  const handleSelectReferal = (value) => {
    setSelectedReferal(value);
  };

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
    setPage(1);
    setPazeSize(value === "All" ? total : parseInt(value));
  };

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/usersList`;
    const kyc = transformStatus(selectedOccupation);
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        params: {
          page: page,
          search: searchInputApi,
          userType: "partner",
          status: kyc,
          perPage: selectNumber === "All" ? total : parseInt(selectNumber),
        },
      });
      setInvestorDetails(response?.data?.data?.users);
      setPage(response?.data?.data?.pagination?.currentPage);
      setTotal(response?.data?.data?.pagination?.totalRecords);
      setPazeSize(response?.data?.data?.pagination?.perPage); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, [page, selectedOccupation, searchInputApi, selectNumber]);

  // Add useEffect to handle automatic search when input is cleared
  useEffect(() => {
    if (searchInput === "") {
      setSearchInputApi("");
    }
  }, [searchInput]);

  function formatStatus(input) {
    if (!input) return ""; // Handle empty or undefined input
    return input.replace(/_/g, " ").replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }

  const columns = [
    // columnHelper.display(
    //   {
    //   id: "sn", // A unique ID for the column
    //   cell: (info) => {
    //     const status = info?.row?.original?.status;
    //     return (
    //       <div
    //         className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm ${
    //           status === "Completed" ? "bg-[#31A653]" : "bg-[#FFB819]"
    //         }`}
    //       >
    //         {info.row.index + 1}
    //       </div>
    //     );
    //   },
    //   header: () => <span>Sr. No.</span>,
    // }),
    columnHelper.accessor("partnerReferralCode", {
      cell: (info) => info.renderValue(),
      header: () => <span>IRA Code</span>,
    }),

    columnHelper.accessor("name", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Wealth Partner Name</span>
        </div>
      ),
    }),
    columnHelper.accessor("kycStatus", {
      // cell: (info) => (info.renderValue() ? info.renderValue() : "N/A"),
      cell: (info) => {
        const kycStatus = info?.row?.original?.kycStatus;
        return (
          <div
            className={` ${
              kycStatus === "approve"
                ? "text-[#31A653]"
                : kycStatus === "under_review"
                ? "text-[#FF7900]"
                : kycStatus === "query" || kycStatus === "rejected"
                ? "text-[#E91518]"
                : kycStatus === "update_request"
                ? "text-[#3B68DD]"
                : "text-[#FFB400]"
            }`}
          >
            {formatStatus(kycStatus)}
          </div>
        );
      },
      header: () => <span>KYC Status</span>,
    }),
    columnHelper.accessor("createdAt", {
      cell: (info) => {
        let createdAt = info?.getValue();
        // Check if the date value exists before formatting
        createdAt = createdAt ? moment(createdAt).format("DD-MM-YYYY") : "N/A";
        return createdAt;
      },
      header: () => <span>Registration Date</span>,
    }),
    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        console.log("investorid", uniqueId);
        const NavigateScheme = (uniqueId) => {
          navigate("/registration/wealth-partner/details", {
            state: {
              uniqueId: uniqueId,
            },
          });
        };
        return (
          <div
            className="flex flex-start "
            onClick={() => NavigateScheme(uniqueId)}
          >
            <img src={eye} alt="Eye " className="cursor-pointer" />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  const handleSearchInput = (value) => {
    setSearchInput(value);
  };
  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  const downloadRegistorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/usersList/export-to-excel`;
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        params: {
          userType: "partner",
          search: searchInput, // Pass `searchInput` as a query parameter
        },
        responseType: "blob",
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary link to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "investor_details.xlsx"; // Provide a default file name

      // Append the link to the document and trigger the click
      document.body.appendChild(link);
      link.click();

      // Clean up the link and blob URL
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      console.log("File downloaded successfully!");
      console.log(response, "response-download");
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const onDownloadClick = () => {
    downloadRegistorDetails();
  };

  return (
    <div className="mt-20 px-4">
      {buttonData.map((button, index) => (
        <button
          key={index}
          className={`w-[135px] text-[14px] px-4 py-2   ${
            activeTab === button.label ? "bg-[#035C98] text-white " : ""
          } ${
            index === 0 ? "rounded-l" : "rounded-r"
          } focus:outline-none focus:ring-2`}
          onClick={() => handleClick(button.path, button.label)} // Navigate on click
        >
          {button.label}
        </button>
      ))}
      <div className="bg-white px-8 py-2 mt-10 rounded-[10px] overflow-auto">
        <div className="w-full flex justify-between">
          <h1 className="text-[#252C32] text-[24px]">Wealth Partner </h1>
          <button
            onClick={() => setIsOpenInviteModal(true)}
            className="bg-[#035C98] text-white px-3 rounded-md"
          >
            Invite Partner
          </button>
        </div>
        <div class="">
          <div class="flex justify-between  items-center gap-x-2 py-4 gap-y-4">
            <div className="flex flex-wrap gap-2">
              <div class="flex ">
                <input
                  type="text"
                  placeholder="Search by Unique ID/name"
                  className="rounded-l-[8px] w-[217px]"
                  value={searchInput}
                  onChange={(e) => handleSearchInput(e?.target?.value)}
                />
                <button
                  onClick={handleSearchClick}
                  className=" bg-[#035C98] text-white font-bold py-2 px-4 rounded-r-[8px]"
                >
                  Search
                </button>
              </div>
              <div class="flex items-center">
                <div className="flex items-center flex-wrap gap-2">
                  <label className="text-[12px] min-w-[148px] px-2">
                    OR search by KYC Status
                  </label>

                  <div className="w-[136px]">
                    <SelectButton
                      options={optionsOccupation}
                      selectedValue={selectedOccupation}
                      onSelect={handleSelectOccupation}
                    />
                  </div>
                </div>
                {/* <div className="flex items-center">
                <label className="text-[12px] min-w-[165px] px-2">
                  Referred by Wealth Partner
                </label>

                <SelectButton
                  options={optionsRefered}
                  selectedValue={selectedReferal}
                  onSelect={handleSelectReferal}
                />
              </div> */}
              </div>
              {userPermissionData?.registration?.download && (
                <div
                  onClick={onDownloadClick}
                  class="flex items-center bg-[#035C98] px-4 rounded-[8px]"
                >
                  <button class="btn   text-white font-bold  ">Download</button>
                  <img src={download} alt="download" />
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center w-[154px]">
            <p className="pr-1">Show</p>
            <SelectButton
              options={optionsShow}
              selectedValue={selectNumber}
              onSelect={handleSelectNumber}
            />
            <p className="pl-1">Entries</p>
          </div>
        </div>
      </div>

      <div className="w-full font-poppins mt-3 pt-4 bg-white rounded-[10px]">
        <ReactTable
          key={JSON?.stringify(investorDetails)}
          defaultData={investorDetails}
          columns={columns}
        />
      </div>

      {investorDetails?.length > 0 && (
        <div className="w-auto">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={pageSize}
            maxPageNumbersToShow={5}
            storageKey="registrationManagementPartnerPage"
          />
        </div>
      )}
      <InvitePartner
        isOpenInviteModal={isOpenInviteModal}
        setIsOpenInviteModal={setIsOpenInviteModal}
      />
    </div>
  );
}

export default RestrationManagementPartner;
